const isEmail = email => {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

const required = (value) => {
  return value ? "" : "Field is required";
}

const phone = (value) => {
  return value && /\(?([0][0-9]{2})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(value) ? "" : "Phone is invalid";
}

const minLenght = (value, length = 5) => {
  return value && value.length >= length ? "" : "Please enter a valid password";
}

const maxLenght = (value, length = 40) => {
  return value && value.length < length ? "" : "This password is too long";
}

const comparePassword = (value, confirmValue) => {
  return value != confirmValue ? "Password not match" : "";
}

const insertValidateText = ({validateText, insertAfterId, errorsElement='errors'}) => {
  const validatePattern = `<div class='errors'>${validateText}</div>`;

  if ($(errorsElement).length) {
    return $(errorsElement).replaceWith(validatePattern);
  }

  return $(validatePattern).insertAfter(insertAfterId);
}

const emailValidation = ({id, insertAfterId, errorsElement='errors'}) => {
  const email = $(id).val();
  const isError = !isEmail(email);
  const validateText = email ? 'Email contains an invalid domain name.' : 'Please enter a valid email address';

  if (isError) {
    insertValidateText({
      validateText,
      insertAfterId,
      errorsElement
    });
    return false;
  }

  return true;
}